// export const apiUrl = 'http://127.0.0.1:8000/api'
export const apiUrl =
  "https://mahalaxmi.tribeappsoft.in/MahalaxmiBackend/public/api";
